/* Shopify Forms renders in an open shadow root. Keep its existing form/consent
   flow; only repair the unlabelled overlay and translucent field-label colour. */
(() => {
  const pending = new WeakSet();
  let headingId = 0;
  function watch(host) {
    if (pending.has(host)) return;
    pending.add(host);
    let attempts = 0;
    function connect() {
      if (!host.isConnected) return;
      const root = host.shadowRoot;
      if (!root) {
        if (++attempts < 80) window.setTimeout(connect, 250);
        return;
      }
      const style = document.createElement('style');
      style.textContent = '#app-embed label[for] { color: #6A2238 !important; }';
      root.appendChild(style);
      function labelDialogs() {
        root.querySelectorAll('[role="dialog"], [role="alertdialog"]').forEach(dialog => {
          if (dialog.getAttribute('aria-label') || dialog.getAttribute('aria-labelledby')) return;
          const heading = dialog.querySelector('h1, h2, h3, [role="heading"]');
          if (heading) {
            if (!heading.id) heading.id = `oc-forms-heading-${++headingId}`;
            dialog.setAttribute('aria-labelledby', heading.id);
          }
        });
      }
      labelDialogs();
      new MutationObserver(labelDialogs).observe(root, { childList: true, subtree: true });
    }
    connect();
  }
  function findHosts(node) {
    if (node.nodeType !== 1) return;
    if (node.matches('shopify-forms-embed')) watch(node);
    node.querySelectorAll('shopify-forms-embed').forEach(watch);
  }
  findHosts(document.documentElement);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(findHosts)))
    .observe(document.documentElement, { childList: true, subtree: true });
})();
